export default {
    id: 'លេខសម្គាល់',
    invoice_id: 'លេខសម្គាល់វិក្ក័យប័ត្រ',
    username: 'ឈ្មោះ​អ្នកប្រើ',
    service: 'សេវាកម្ម',
    reg_date: 'កាលបរិច្ឆេទចុះឈ្មោះ',
    amount: 'ចំនួនទឹកប្រាក់',
    refund: 'សងប្រាក់វិញ។',
    status: 'ស្ថានភាព',
    payment: 'ការទូទាត់',
    edit: 'កែសម្រួល',
    view_log: 'មើលកំណត់ហេតុ',
    edit_title: 'កែសម្រួលវិក្ក័យប័ត្រ',
    description_service: 'សេវាកម្មបរិយាយ',
    unit_price: 'តម្លៃ​ឯកតា',
    discount: 'បញ្ចុះតម្លៃ',
    total_discount: 'ការបញ្ចុះតម្លៃសរុប',
    description: 'ការបរិយាយ',
    phone: 'លេខទូរសព្ទ',
    full_name: 'ឈ្មោះ​ពេញ',
    bank_name: 'ឈ្មោះ​ធនាគារ',
    account_name: 'ឈ្មោះ​គណនី',
    account_number: 'លេខ​គណនី',
    branch: 'សាខា',
    branch_code: 'លេខសម្ងាត់សាខា',
    transfer_amount: 'ចំនួនផ្ទេប្រាក់',
    transfer_description: 'បរិយាយការផ្ទេរ',
    sub_total: 'សរុបរង',
    tax_rate: 'អត្រាពន្ធ',
    taxWithPercent: 'ពន្ធ ({percent}%)',
    vatWithPercent: 'VAT ({percent}%)',
    whtWithPercent: 'ពន្ធកាត់ទុក ({percent}%)',
    taxWithoutPercent: 'ពន្ធ',
    whtWithoutPercent: 'ពន្ធកាត់ទុក',
    total: 'សរុប',
    for: 'សម្រាប់',
    failed_service: 'សេវាកម្ម {failedService} បានបរាជ័យ',
    my_invoice_info: 'ព័ត៌មានវិក្ក័យប័ត្រ',
    promotion_code: 'លេខ​កូដ​ប្រូ​ម៉ូ​សិន',
    invoice_list: 'បញ្ជីវិក្ក័យប័ត្រ',
    my_invoice_detail: 'ព័ត៌មានលម្អិតវិក័យប័ត្រ',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    detail: 'លម្អិត',
    days: 'ថ្ងៃ',
    months: 'ខែ',
    years: 'ឆ្នាំ',
    register_action: 'ការចុះឈ្មោះ',
    renew_action: 'ការបន្ត',
    reactivate_action: 'ធ្វើឱ្យសកម្មឡើងវិញ',
    transfer_action: 'ផ្ទេរ',
    purchase_action: 'ការទិញ',
    upgrade_action: 'តំឡើង',
    backup_action: 'បម្រុងទុក',
    server_name: 'ឈ្មោះម៉ាស៊ីនមេ',
    website_name: 'ឈ្មោះគេហទំព័រ',
    connected_with: 'ភ្ជាប់ជាមួយ',
    from: 'ពី',
    machine_name: 'ឈ្មោះម៉ាស៊ីន',
    payment_method: 'វិធី​សា​ស្រ្ត​ទូទាត់',
    transaction_id: 'លេខ​សម្គាល់​ប្រតិ​ប​ត្ដិ​ការ',
    purchase_id: 'លេខសម្គាល់ការទិញ',
    payment_fee: 'ថ្លៃសេវា PayPal',
    payway_fee: 'ថ្លៃសេវា PayWay',
    payment_amount: 'ចំនួនទឹកប្រាក់ទូទាត់',
    refund_amount: 'ចំនួនទឹកប្រាក់សងមកវិញ។',
    type: 'ប្រភេទ',
    qty: 'បរិមាណ',
    upgrade_fee: 'ថ្លៃតំឡើង',
    edit_company_info: 'កែសម្រួលព័ត៌មានក្រុមហ៊ុន',
    order_summary: 'តារាងសង្ខេបនៃការបញ្ជាទិញ',
    excluding_vat: 'មិនរាប់បញ្ចូលពន្ធលើតម្លៃបន្ថែម: {taxes}',
    card_number: 'លេខ កាត',
    amount_from: 'ចំនួនទឹកប្រាក់ពី',
    download_vat_invoice: 'ទាញយកវិក្កយបត្រ VAT',
    aws_waiting_for_payment_description:
        'វិក្កយបត្រនេះត្រូវបានបង្កើតដោយស្វ័យប្រវត្តិសម្រាប់សេវាកម្ម AWS មិនត្រូវបានបង់ទេ។',
    waiting_for_payment: 'រង់ចាំការទូទាត់',
    service_id: 'សេវាកម្ម ID',
    service_id_placeholder: 'សេវាកម្ម ID',
    swift_code: 'លេខកូដ SWIFT',
    aws_account: 'គណនី AWS',
    support_hours_des:
        'ការគាំទ្រសម្រាប់អតិថិជនទាំងអស់ - សរុប {supportHours} ម៉ោង។',
};
